<app-toolbar></app-toolbar>

<div *ngIf="isLoading">
  <app-loading></app-loading>
</div>
<div class="main-layout content">
  <!-- Left Card -->
  <div class="left-card">
    <div class="card">
      <div *ngIf="!isLoading">
        <h1 class="title">{{ contextData?.scenario_title }}</h1>
        <h2 class="subtitle">Main Role: {{ contextData?.main_role }}</h2>
      </div>

      <div class="card-content" *ngIf="!isLoading">
        <p class="body-text">
          {{ contextData?.context }}
        </p>
        <div class="body-text context-section">
          <strong> Challenges You Will Face: </strong>
          <br />
          <br />

          <ul class="context-list">
            <li
              *ngFor="let item of getFormattedChallengeItems()"
              [innerHTML]="item"
            ></li>
          </ul>
        </div>

        <p class="body-text">
          {{ contextData?.mission }}
        </p>
        <p class="body-text">
          {{ contextData?.final_message }}
          <strong>
            {{ contextData?.question }}
          </strong>
        </p>
      </div>

      <div class="card-actions" *ngIf="!isLoading">
        <button class="btn back-btn" (click)="navigateToUrl('/dashboard')">
          Back
        </button>
        <button class="btn start-btn" (click)="startTest()">
          Start Simulator
        </button>
      </div>
    </div>
  </div>

  <!-- Right Side -->
  <div class="right-side">
    <div class="org-chart-box">
      <h4 class="org-chart-title">Organizational chart</h4>
      <!-- Organization chart component or content here -->
      <div class="org-chart-zoom" [style.zoom]="zoom">
        <app-organization-chart
          [organizationChart]="organizationChart"
          [showCheckBox]="false"
          [showPhaseIndicator]="false"
        ></app-organization-chart>
      </div>
      <div class="zoom-btns-container">
        <button class="zoom-btns" (click)="decreaseZoom()">-</button>
        <button class="zoom-btns" (click)="increaseZoom()">+</button>
      </div>
    </div>
  </div>
</div>
